import React from 'react';
import { Card, CardContent } from '../components/ui/card';
import { Linkedin, Twitter } from 'lucide-react';

const Guests = () => {
  const guests = [
    {
      id: 1,
      name: "Shubhayu Sengupta",
      role: "HR Leader & Transformation Expert",
      episode: "What AI Can't Replace in HR",
      image: "https://customer-assets.emergentagent.com/job_751d7503-a1f9-4307-b026-754ff698f3bd/artifacts/lai11fs7_1.jpg",
      linkedin: "#"
    },
    {
      id: 2,
      name: "Andrew Wallbridge",
      role: "Global Leadership Coach & Author",
      episode: "Leader's Labyrinth",
      image: "https://customer-assets.emergentagent.com/job_751d7503-a1f9-4307-b026-754ff698f3bd/artifacts/9xndlekx_3.jpg",
      linkedin: "#"
    },
    {
      id: 3,
      name: "Anjali Dutta",
      role: "Digital Transformation Leader",
      episode: "Human-First Leadership in a Tech-Driven World",
      image: "https://customer-assets.emergentagent.com/job_751d7503-a1f9-4307-b026-754ff698f3bd/artifacts/2bagy4zw_4.jpg",
      linkedin: "#"
    }
  ];

  return (
    <div className="min-h-screen pt-24 pb-20 bg-dark-bg">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="mb-16 pt-8">
          <p className="text-gold text-xs font-medium uppercase tracking-widest mb-4">
            Featured Voices
          </p>
          <h1 className="text-4xl md:text-5xl font-bold text-warm-white mb-4 tracking-tight">
            Our Guests
          </h1>
          <p className="text-warm-white/60 max-w-2xl">
            Conversations with leaders, thinkers, and practitioners who bring unique perspectives on learning, leadership, and growth.
          </p>
        </div>

        {/* Guests Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {guests.map((guest) => (
            <Card
              key={guest.id}
              className="overflow-hidden hover:border-gold/50 transition-all duration-300 group border border-dark-border bg-dark-card"
            >
              <div
                className="h-64 bg-cover bg-center relative"
                style={{ backgroundImage: `url(${guest.image})` }}
              >
                <div className="absolute inset-0 bg-gradient-to-t from-dark-bg via-dark-bg/40 to-transparent"></div>
              </div>
              <CardContent className="p-6">
                <h3 className="text-xl font-bold text-warm-white mb-1 group-hover:text-gold transition-colors">
                  {guest.name}
                </h3>
                <p className="text-gold text-xs uppercase tracking-wider mb-4">
                  {guest.role}
                </p>
                <p className="text-warm-white/60 text-sm mb-4">
                  Featured in: <span className="text-warm-white/80">{guest.episode}</span>
                </p>
                <div className="flex gap-3">
                  <a
                    href={guest.linkedin}
                    className="w-10 h-10 bg-dark-bg border border-dark-border hover:border-gold hover:text-gold flex items-center justify-center transition-all duration-300 text-warm-white/60"
                  >
                    <Linkedin className="w-4 h-4" />
                  </a>
                  <a
                    href="#"
                    className="w-10 h-10 bg-dark-bg border border-dark-border hover:border-gold hover:text-gold flex items-center justify-center transition-all duration-300 text-warm-white/60"
                  >
                    <Twitter className="w-4 h-4" />
                  </a>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>

        {/* CTA */}
        <div className="mt-20 text-center">
          <div className="bg-dark-card border border-dark-border p-12 max-w-2xl mx-auto">
            <h2 className="text-2xl font-bold text-warm-white mb-4 tracking-tight">
              Want to Be a Guest?
            </h2>
            <p className="text-warm-white/60 mb-8">
              We're always looking for leaders with unique perspectives on learning, growth, and intentional living.
            </p>
            <a
              href="/contact"
              className="inline-block bg-gold hover:bg-gold/90 text-dark-bg font-semibold text-xs uppercase tracking-wider px-8 py-4 transition-all duration-300"
            >
              Apply to Be a Guest
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Guests;
